/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection06FoiChanged, m11ReportSection06ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection06Foi, selectM11ReportSection06Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialInterventionChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section06State, setAlertModalState, setStartingSection06State) => {

    let changesStates = {
        section06State: section06State
    };
    let response = await saveM11Changes(apiToken, 22, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection06Resource) {
            dispatch(m11ReportSection06ResourceChanged(response.m11ReportSection06Resource));
        }
        setStartingSection06State(JSON.parse(JSON.stringify(section06State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step022TrialInterventionPart2 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection06Foi = useSelector(selectM11ReportSection06Foi);
    const m11ReportSection06Resource = useSelector(selectM11ReportSection06Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section06State, setSection06State] = useState({
        "section61Status": "empty", "section61Xhtml": "",
        "section62Status": "empty", "section62Xhtml": "",
        "section63Status": "empty", "section63Xhtml": "",
        "section64Status": "empty", "section64Xhtml": "",
        "section65Status": "empty", "section65Xhtml": ""
    });
    const [startingSection06State, setStartingSection06State] = useState({
        "section61Status": "empty", "section61Xhtml": "",
        "section62Status": "empty", "section62Xhtml": "",
        "section63Status": "empty", "section63Xhtml": "",
        "section64Status": "empty", "section64Xhtml": "",
        "section65Status": "empty", "section65Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section06State, startingSection06State)),
        async saveAllChanges() {
            await saveTrialInterventionChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section06State, setAlertModalState, setStartingSection06State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section61Status": "empty", "section61Xhtml": "",
                "section62Status": "empty", "section62Xhtml": "",
                "section63Status": "empty", "section63Xhtml": "",
                "section64Status": "empty", "section64Xhtml": "",
                "section65Status": "empty", "section65Xhtml": "",
                "loaded": true
            };
            setSection06State(startingData);
            setStartingSection06State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[6]?.entry?.length) {
                let m11ReportSection006Foi = getIdFromReference(m11ReportContainerResource.section[6].entry[0]);
                if (m11ReportSection006Foi && !isNaN(m11ReportSection006Foi) && m11ReportSection006Foi !== m11ReportSection06Foi) {
                    dispatch(m11ReportSection06FoiChanged(m11ReportSection006Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection06Foi && !isNaN(m11ReportSection06Foi)) {
            loadResource(m11ReportSection06Foi, "M11ReportSection06", apiToken, dispatch);
        }
    }, [m11ReportSection06Foi]);

    useEffect(() => {
        if (m11ReportSection06Resource && Object.keys(m11ReportSection06Resource).length > 0) {
            let startingData = {
                "section61Status": "empty", "section61Xhtml": "",
                "section62Status": "empty", "section62Xhtml": "",
                "section63Status": "empty", "section63Xhtml": "",
                "section64Status": "empty", "section64Xhtml": "",
                "section65Status": "empty", "section65Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection06Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection06Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section61Status = m11ReportSection06Resource.section[0].section[0].text.status;
                    startingData.section61Xhtml = m11ReportSection06Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section62Status = m11ReportSection06Resource.section[0].section[1].text.status;
                    startingData.section62Xhtml = m11ReportSection06Resource.section[0].section[1].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section63Status = m11ReportSection06Resource.section[0].section[2].text.status;
                    startingData.section63Xhtml = m11ReportSection06Resource.section[0].section[2].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[3]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[3].text.status !== "empty") {
                    startingData.section64Status = m11ReportSection06Resource.section[0].section[3].text.status;
                    startingData.section64Xhtml = m11ReportSection06Resource.section[0].section[3].text.div;
                }
                if (m11ReportSection06Resource.section[0].section[4]?.text?.div &&
                    m11ReportSection06Resource.section[0].section[4].text.status !== "empty") {
                    startingData.section65Status = m11ReportSection06Resource.section[0].section[4].text.status;
                    startingData.section65Xhtml = m11ReportSection06Resource.section[0].section[4].text.div;
                }
                setSection06State(startingData);
                setStartingSection06State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection06Resource]);

    return <div>
        <h3>Complete Section 6.1 to 6.5 for Investigational Trial Intervention.</h3>
        {!(m11ReportSection06Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 22 (Complete Section 6.1 to 6.5 for Investigational Trial Intervention) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section06State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.1 Description of Investigational Trial Intervention.</h4>
                    <TextDivEntry elementName="section61Xhtml"
                        startingValue={section06State.section61Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen.</h4>
                    <TextDivEntry elementName="section62Xhtml"
                        startingValue={section06State.section62Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.3 Investigational Trial Intervention Administration.</h4>
                    <TextDivEntry elementName="section63Xhtml"
                        startingValue={section06State.section63Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.4 Investigational Trial Intervention Dose Modification.</h4>
                    <TextDivEntry elementName="section64Xhtml"
                        startingValue={section06State.section64Xhtml}
                        setResourceState={setSection06State} />
                    <h4 style={{ marginBottom: "0px" }}>Enter data for Section 6.5 Management of Investigational Trial Intervention Overdose.</h4>
                    <TextDivEntry elementName="section65Xhtml"
                        startingValue={section06State.section65Xhtml}
                        setResourceState={setSection06State} />
                </>}
            </>
        }
    </div >
});

const M11Step022TrialInterventionPart2HelperText = <div>
    <h3>Complete Section 6.1 to 6.5 for Investigational Trial Intervention.</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 6.1 Description of Investigational Trial Intervention.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the investigational trial intervention to be administered in each arm of the trial and for each period of the trial including route and mode of administration, dose, dosage regimen, duration of intervention, use, packaging and labelling.</p>
            <p>Refer to approved regional labelling, as appropriate.</p>
            <p>For investigational drug/device combination products, include details on the configuration and use of the device and device manufacturer. A device user manual may be referenced in this section.</p>
        </div>
        <p>Enter data for Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Provide a rationale for the selection of the dose(s) or dose range, pharmaceutical dose form, route of administration, and dosing regimen of the investigational trial interventions, as applicable. This rationale should include relevant results from nonclinical studies and clinical trials that support selection of the dose and regimen. Discuss impact of differences in trial population characteristics (e.g., age, sex, race) that could lead to differences in pharmacokinetics and pharmacodynamics in this trial as compared to previous trials. If applicable, justify any differences in dose regimen or therapeutic use relative to approved labelling. Describe prior trials and other information that support the dose and/or dose regimen of the investigational trial intervention.</p>
            <p>Include a rationale for prospective dose adjustments incorporated in the trial, if any.</p>
        </div>
        <p>Enter data for Section 6.3 Investigational Trial Intervention Administration.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the detailed procedures for administration of each participant’s dose of each investigational trial intervention. This may include the timing of dosing (e.g., time of day, interval), the duration (e.g., the length of time participants will be administered the investigational trial intervention), and the timing of dosing relative to meals.</p>
            <p>Include any specific instructions on who, when or how to prepare and take the dose(s) and how to handle any delayed or missed doses.</p>
            <p>Dose escalation or cohort expansion as part of the overall design should be covered in Section 4.1 Description of Trial Design.</p>
        </div>
        <p>Enter data for Section 6.4 Investigational Trial Intervention Dose Modification.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>For each participant, describe any dose modifications allowed, including conditions for such dose modifications, particularly regarding failure to respond or safety concerns. State any minimum period required before a participant’s dose might be raised to the next higher dose or dose range. Include whether it is permissible to start and stop treatment and how dose reductions (if permitted) are to be managed.</p>
            <p>Information on stopping investigational trial intervention for participants due to safety/other reasons should be described in Section 7 Participant Discontinuation of Trial Intervention and Discontinuation or Withdrawal from Trial.</p>
        </div>
        <p>Enter data for Section 6.5 Management of Investigational Trial Intervention Overdose.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe what is meant by investigational trial intervention overdose. Provide any available information on managing overdose and ensure it is consistent with the Investigator’s Brochure or product labelling. Cross reference these documents as applicable.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step022TrialInterventionPart2ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 22, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 22 (Complete Section 6.1 to 6.5 for Investigational Trial Intervention) {validationCheckState.step22numberOfChecks} issues checked. {validationCheckState.step22numberPassed} passed. {validationCheckState.step22numberFailed} failed.</h4>
        <p>Section 6.1 heading is 'Description of Investigational Trial Intervention': {validationCheckState.resultCheckSection61Heading}</p>
        <p>Section 6.1 Description of Investigational Trial Intervention has content: {validationCheckState.resultCheckSection61Content}</p>
        <p>Section 6.2 heading is 'Rationale for Investigational Trial Intervention Dose and Regimen': {validationCheckState.resultCheckSection62Heading}</p>
        <p>Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen has content: {validationCheckState.resultCheckSection62Content}</p>
        <p>Section 6.3 heading is 'Investigational Trial Intervention Administration': {validationCheckState.resultCheckSection63Heading}</p>
        <p>Section 6.3 Investigational Trial Intervention Administration has content: {validationCheckState.resultCheckSection63Content}</p>
        <p>Section 6.4 heading is 'Investigational Trial Intervention Dose Modification': {validationCheckState.resultCheckSection64Heading}</p>
        <p>Section 6.4 Investigational Trial Intervention Dose Modification has content: {validationCheckState.resultCheckSection64Content}</p>
        <p>Section 6.5 heading is 'Management of Investigational Trial Intervention Overdose': {validationCheckState.resultCheckSection65Heading}</p>
        <p>Section 6.5 Management of Investigational Trial Intervention Overdose has content: {validationCheckState.resultCheckSection65Content}</p>
    </div>}  </div>
}

export default M11Step022TrialInterventionPart2;
export { M11Step022TrialInterventionPart2HelperText, M11Step022TrialInterventionPart2ValidationCheck };